import * as React from "react";
import { useArrayField } from "informedv4";
import { TimePicker } from "../../forms/informedv4/TimePickerV4";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export const SubjectAlarms = () => {

    const arrayFieldApiRef = React.useRef();


    const { render, arrayFieldApi, arrayFieldState } = useArrayField({
        name: "Alarms",
        arrayFieldApiRef: arrayFieldApiRef,
    } as any); 

    return render(
        <>
            <div className="row">
                <h3 className="col-md-12 text-primary">Alarms</h3>
            </div>
            <div className="row">
                {arrayFieldState.fields.map(({ arrayFieldItemState, arrayFieldItemApi }) => (
                    <div key={arrayFieldItemState.key} className="form-group col-md-4 col-sm-4 col-xs-12">
                        <TimePicker
                            id={arrayFieldItemState.name}
                            field={arrayFieldItemState.name}
                            label="Alarm"
                            required={true}
                            placeholderText="HH:mm (24 hour format)"
                            dateFormat="HH:mm"
                            suffix={
                                <FontAwesomeIcon
                                    icon={faXmark}
                                    className="text-danger"
                                    onClick={arrayFieldItemApi.remove}
                                    style={{ cursor: "pointer" }}
                                />
                            }
                        />
                    </div>
                ))}
            </div>
            <div className="row">
                <div className="col-md-12">
                    <button
                        id="AddAlarm"
                        className="btn btn-primary btn-outline"
                        type="button"
                        onClick={() => arrayFieldApi.add()}
                    >
                        Add Alarm
                    </button>
                </div>
            </div>
        </>
    );
};
